module.exports = __webpack_public_path__ + "static/media/twitter.328cb98e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Team/AboutBox/img/twitter.svg
// module id = 294
// module chunks = 0